import {SeriesType} from "./SeriesType";
import StartList from "./StartList";

export default class SeriesItem {
  constructor(private readonly _id: string,
              private readonly _type: SeriesType,
              private readonly _arena: string,
              private readonly _difficulty: string,
              private readonly _startHour: number,
              private readonly _startMinutes: number,
              private readonly  _startList: StartList) {
  }


  get id(): string {
    return this._id;
  }

  get type(): SeriesType {
    return this._type;
  }

  get arena(): string {
    return this._arena;
  }

  get difficulty(): string {
    return this._difficulty;
  }

  get startHour(): number {
    return this._startHour;
  }

  get startMinutes(): number {
    return this._startMinutes;
  }

  get startList(): StartList {
    return this._startList;
  }
}

export const isKnownArena = (arena:string) => {
  return arena && !arena.includes("nog niet toegekend");
};
